module.exports = __webpack_public_path__ + "static/media/xiaojun-5.jpeg";